function Footer() {
  return (
    <div className="bg-gray-100 py-2 flex-none text-gray-700">
      <hr className="mt-5"/>
      <div className="container mx-auto text-center pt-3 pb-2 text-sm">
        In case of problems please contact Alexander Ledovsky or Gurgen Soghoyan
      </div>
    </div>
  )
}

export default Footer;